import React from 'react';
import { SpeechMarker, SPEECH_MARKER_LABELS } from '../../../types/annotation';

interface SpeechMarkerCheckboxesProps {
  value: SpeechMarker[];
  onChange: (markers: SpeechMarker[]) => void;
  disabled?: boolean;
}

const MARKER_ORDER: SpeechMarker[] = [
  'pause',
  'long_pause',
  'hesitation',
  'laughter',
  'sigh',
  'interruption',
  'overlap',
  'emphasis',
];

const SpeechMarkerCheckboxes: React.FC<SpeechMarkerCheckboxesProps> = ({
  value,
  onChange,
  disabled = false,
}) => {
  const safeValue = value ?? [];

  const toggle = (marker: SpeechMarker) => {
    if (safeValue.includes(marker)) {
      onChange(safeValue.filter((m) => m !== marker));
    } else {
      onChange([...safeValue, marker]);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-y-1.5 gap-x-4">
      {MARKER_ORDER.map((marker) => {
        const checked = safeValue.includes(marker);
        return (
          <label
            key={marker}
            className={[
              'flex items-center gap-2 text-sm cursor-pointer select-none',
              disabled ? 'opacity-50 cursor-not-allowed' : '',
            ].join(' ')}
          >
            <input
              type="checkbox"
              checked={checked}
              onChange={() => toggle(marker)}
              disabled={disabled}
              className="w-3.5 h-3.5 rounded border-gray-300 text-violet-600 focus:ring-violet-500 accent-violet-600"
            />
            <span className={checked ? 'text-violet-700 font-medium' : 'text-gray-600'}>
              {SPEECH_MARKER_LABELS[marker]}
            </span>
          </label>
        );
      })}
    </div>
  );
};

export default SpeechMarkerCheckboxes;
